import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Imię jest za krótkie.')
        .max(50)
        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię.'),
    email: Yup
        .string()
        .email('Ta wartość nie jest prawidłowym adresem email.')
        .max(255).test('is-email-required', 'Ta wartość nie powinna być pusta', function (value) {
            const agreeCommunication = this.parent.agreeCommunication;
            if (agreeCommunication.includes('email')) return !!value;
            return true;
        }),
    phone: Yup
        .string()
        .required("Ta wartość nie powinna być pusta.")
        .matches(/^\d{9}$/, 'Podaj nr\u00a0telefonu w\u00a0formacie 123456789.')
        .max(9),
    date: Yup
        .string()
        .required('Ta wartość nie powinna być pusta.')
        .notOneOf([''], 'Wybierz termin'),
    agreeData: Yup.boolean()
        .when('agreeCommunication', {
            is: (val) => val && val.length > 0,
            then: (schema) => schema.isTrue('Zaznacz, jeśli wybrałeś minimum jedną z\u00a0poniższych opcji.'),
        }),
    agreeCommunication: Yup.array()
        .when('agreeData', {
            is: (val) => true === val,
            then: (schema) => schema.min(1, 'Wybierz minimum jedną opcję.'),
        }),
}, ['agreeData', 'agreeCommunication']);

